/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitializeTaxDeclarationManuallyCommand } from '../../models/initialize-tax-declaration-manually-command';

export interface ApiTaxDeclarationInitializePost$Json$Params {
      body: InitializeTaxDeclarationManuallyCommand
}

export function apiTaxDeclarationInitializePost$Json(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializePost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializePost$Json.PATH = '/api/TaxDeclaration/initialize';
